import View from './View';

export default class ZindexView extends View {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
}
